<template>
  <div
    data-testid="skip-message"
    class="gc-pt-4 gc-mt-8 gc-border-gray-100 gc-border-t"
  >
    <p class="gc-text-sm gc-text-gray-400 gc-mb-0">
      {{ $t('skipMessage') }}
      <a class="gc-text-primary" @click="onClickSkip()">{{
        $t('goToContactForm')
      }}</a>
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  setup: (_, { emit }) => {
    const onClickSkip = () => {
      emit('skip');
    };

    return { onClickSkip };
  },
});
</script>

<style></style>
